import React from 'react'
import { FormularyCoveragePlan } from '@teschglobal/tg-fhir-react-components'
import type { CombinedList, List} from '@teschglobal/tg-fhir-react-components/dist/types/list'
import FhirLoader from '../../../../FhirLoader'

type FormularyCoveragePlanDetailProps = {
    resource: List | null
    isFetching: boolean
}

const FormularyCoveragePlanDetail: React.FC<FormularyCoveragePlanDetailProps> = ({
    resource,
    isFetching,
}) => {
    if (isFetching) return <FhirLoader />
    if (!resource) {
        return (
            <div className="text-center" role="status" aria-live="polite">
                Not Found
            </div>
        )
    }
    const fhirResource = resource as unknown as CombinedList

    return (
        <section>
            <h3>List (Formulary Coverage Plans)</h3>
            <FormularyCoveragePlan data={fhirResource} />
        </section>
    )
}

export default FormularyCoveragePlanDetail
